import { render } from "./HelpDialogWorkflow.vue?vue&type=template&id=6e81f2e6"
import script from "./HelpDialogWorkflow.vue?vue&type=script&lang=js"
export * from "./HelpDialogWorkflow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__